import React, {Component} from 'react'
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"
import Button from "reactstrap/es/Button"
import PropTypes from "prop-types"
import {
    getExportItemsCSVv4,
    getExportItemsCSVBySku,
    getExportItemsCSVByOrder
} from "../../../../services/api/apiNextBox"
import {CSVLink} from "react-csv"

class ExportModal extends Component {
    state = {
        type: 'default',
        exporting: false,
        errorExport: '',
        dataExport: ''
    }

    _handleChangeType = (e) => {
        const {value} = e.target

        this.setState({
            type: value
        })
    }

    _exportItems = () => {
        const {type} = this.state

        this._exportCSV(type)
    }

    _exportCSV = async (type) => {
        this.setState({
            exporting: true
        })

        const {filter, onToggleModal} = this.props

        try {
            let exportApi = getExportItemsCSVv4

            if (type === 'sku') {
                exportApi = getExportItemsCSVBySku
            } else if (type === 'order') {
                exportApi = getExportItemsCSVByOrder
            }

            const filterClone = {...filter}
            
            if(filter.partners){
                filterClone.partners = [filter.partners]
            }else{
                delete filterClone.partners
            }

            const payload = {
                ...filterClone,
                option: type
            }
            if (type === 'itemBox') {
                payload.option = 'default'
                payload.action = 'export_item_thung'
            }
            const res = await exportApi(payload)

            await this.setState({
                exporting: false,
                dataExport: res.data
            })

            await this.csvLink.link.click()
            await onToggleModal()

        } catch (e) {
            this.setState({
                errorExport: e.message,
                exporting: false
            })
        }
    }

    render() {
        const {type, exporting, errorExport, dataExport} = this.state
        const {isOpen, onToggleModal} = this.props
        let filename = type === 'default' ? 'items.csv' : (type === 'sku') ? 'item_sku.csv' : 'item_order.csv'

        return <Modal isOpen={isOpen} className="ExportModal"
        >
            <ModalHeader>
                Export
            </ModalHeader>
            <ModalBody>
                <h5 className="mb-2">Loại báo cáo:</h5>
                <div className="d-flex align-items-center">
                    <div className="item mr-3">
                        <input type="radio" id="report1" name="typeReport" value="default" className="mr-1"
                               checked={type === 'default'} onChange={this._handleChangeType}/>
                        <label className="mb-0" htmlFor="report1">Chi tiết</label>
                    </div>
                    <div className="item mr-3">
                        <input type="radio" id="report2" name="typeReport" value="sku" className="mr-1"
                               checked={type === 'sku'} onChange={this._handleChangeType}/>
                        <label className="mb-0" htmlFor="report2">Tổng hợp theo SKU</label>
                    </div>
                    <div className="item mr-3">
                        <input type="radio" id="report3" name="typeReport" value="order" className="mr-1"
                               checked={type === 'order'} onChange={this._handleChangeType}/>
                        <label className="mb-0" htmlFor="report3">Tổng hợp theo Order</label>
                    </div>
                    <div className="item mr-3">
                        <input type="radio" id="report4" name="typeReport" value="itemBox" className="mr-1"
                               checked={type === 'itemBox'} onChange={this._handleChangeType}/>
                        <label className="mb-0" htmlFor="report4">Item thùng</label>
                    </div>
                </div>
                <CSVLink
                    data={dataExport}
                    filename={filename}
                    className="hidden"
                    ref={(r) => this.csvLink = r}
                    target="_blank"/>
                {errorExport && <div className="text-danger mt-3">{errorExport}</div>}
            </ModalBody>
            <ModalFooter>
                <div className="d-flex w-100 align-items-center justify-content-between">
                    <Button disabled={exporting} onClick={onToggleModal}>
                        Hủy
                    </Button>
                    <Button disabled={exporting} className="bg-primary ml-2" onClick={this._exportItems}>
                        {exporting && <i className="fa fa-spinner fa-spin mr-1"/>}Export
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    }
}

ExportModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onToggleModal: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
}

export default ExportModal